import is403 from '@Ravnur-Inc/core/transformers/error/is403';
import is404 from '@Ravnur-Inc/core/transformers/error/is404';
import { convertFromError } from '@Ravnur-Inc/notifications/convertFromError';
import { showErrorNotification } from '@Ravnur-Inc/notifications/service';
import { useRouter } from 'vue-router';

export function $processException(e: unknown) {
  convertFromError(e).forEach(showErrorNotification);
}

export function $processPageException(e: unknown) {
  if (is404(e)) {
    useRouter().replace({ name: '404' });
  } else if (is403(e)) {
    useRouter().replace({ name: '403' });
  } else {
    $processException(e);
  }
}
